// src/auth/RequireGroup.jsx
import React from 'react';
import { fetchAuthSession } from 'aws-amplify/auth';
import { useSession } from './SessionProvider.jsx';

export default function RequireGroup({
  anyOf = [],                 // e.g., ['detailer'] or ['management']
  fallback = <div style={{ padding: 16 }}>Checking your access…</div>,
  children,
}) {
  const { initializing, signedIn } = useSession();
  const [checking, setChecking] = React.useState(true);
  const [allowed, setAllowed]   = React.useState(false);

  React.useEffect(() => {
    let alive = true;
    (async () => {
      try {
        if (!signedIn) { if (alive) { setAllowed(false); setChecking(false); } return; }
        const { tokens } = await fetchAuthSession();
        const payload = tokens?.idToken?.payload ?? {};
        const groups =
          payload['cognito:groups'] ||
          payload['groups'] ||
          payload['custom:groups'] ||
          [];
        const ok = anyOf.length ? groups.some(g => anyOf.includes(g)) : true;
        if (alive) setAllowed(ok);
      } catch {
        if (alive) setAllowed(false);
      } finally {
        if (alive) setChecking(false);
      }
    })();
    return () => { alive = false; };
  }, [signedIn, anyOf]);

  if (initializing || checking) return fallback;
  if (!signedIn || !allowed)    return fallback;

  return <>{children}</>;
}
